import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {

  constructor(private http: HttpClient) { }

  downloadFile(fileUrl: string,fileName: string): void {
    // this.http.get(filePath, { responseType: 'blob' }).subscribe(blob => {
    //   const url = window.URL.createObjectURL(blob);
    //   window.open(url);
    // });

    // Create a temporary anchor element
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', fileUrl);
    link.setAttribute('download', fileName);

    // Trigger the click event
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
  }
   
}
